import { c as _c } from "react/compiler-runtime";
const BellInactive = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 4.003a3.594 3.594 0 0 1 3.516 2.847l.016.089.175.05c5.417 1.623 9.31 6.704 9.448 12.564l.003.32v8.819c0 1.813.699 3.345 1.875 4.625l.213.224c1.773 1.801.58 4.827-1.904 4.958l-.167.004-5.952.001a7.496 7.496 0 0 1-14.446 0h-5.953c-2.539 0-3.825-2.988-2.184-4.841l.114-.122c1.232-1.252 1.999-2.752 2.08-4.532l.008-.317v-9.086c0-5.93 3.947-11.01 9.458-12.62l.166-.046.017-.09a3.598 3.598 0 0 1 3.326-2.842L24 4.003zm2.862 34.5h-5.725l.043.063a3.493 3.493 0 0 0 2.414 1.408l.214.018.192.005a3.49 3.49 0 0 0 2.82-1.43l.042-.064zM24.037 10.36l-1.347.193a9.154 9.154 0 0 0-7.845 8.786l-.003.268v9.086c0 2.092-.578 3.944-1.573 5.551l-.167.26h21.795l-.166-.26a10.355 10.355 0 0 1-1.567-5.184l-.006-.367v-8.82c0-4.577-3.255-8.518-7.592-9.286l-.261-.042-1.268-.185z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default BellInactive;